import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { withTranslation, Trans } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import EnhancedTableHead from "./EnhancedTableHead";
import ProductListCard from "./ProductListCard";
import Typography from "@material-ui/core/Typography";
import CardMedia from "@material-ui/core/CardMedia";
import EventEmitter from "../event";
import CustomAddButton from "./CustomAddButton";
import AddToListButton from "./AddToListButton";
import ProductModal from "./partials/ProductModal";
import AddProductButton from "./AddProductButton";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import {
  CODE,
  CUSTOM_SEARCH_BAR,
  IMAGE,
  LIST_PRICE,
  MAIN_FAMILY,
  MANUFACTURER,
  NAME,
  NET_PRICE,
  PRODUCT_IMAGE,
  PVP_NETO,
  REFERENCE,
  STOCK,
} from "./partials/constants";
import { Grid } from "@material-ui/core";
import CardProduct from "./CardProduct";

const styles = (theme) => ({
  textContainer: {
    "max-width": "200px",
    "white-space": "nowrap",
    overflow: "hidden",
    "text-overflow": "ellipsis",
  },
  modalProductDiv: {
    position: "absolute",
    width: "775px",
  },
  listImage: {
    width: "35px",
    height: "35px",
    "max-height": "35px"
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

class TableProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeProductCode: null,
      isProductCardOpen: false,
      selectedProductsCode: [],
      showAddToCart: this.props?.showAddToCart,
      showAddToList: this.props?.showAddToList,
      data: this.props.data,
      rows: this.props.rows,
      lang: this.props.lang,
      logged: this.props.logged,
      express: this.props.express,
      tariff: this.props.tariff,
      sortDirection: this.props.sortDirection,
      sortField: this.props.sortField,
      price_sort: this.props.price_sort,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      cart_product_ids: JSON.parse(this.props.cart_products.product_ids),
      fav_products: this.props.fav_products,
      customFilterManufacturer: this.props.customFilterManufacturer,
      customFilterManufacturerIds: this.props.customFilterManufacturerIds,
      selectProductId: null,
      product_hover_id: "",
      indexHover: null,
      width: 0,
      height: 0,
      //resultsFields
      resultsFields: this.props?.resultsFields
        ?.filter((field) => field.value === 1)
        ?.map((e) => e.key) || [
        "image",
        "manufacturer",
        "reference",
        "name",
        "net_price",
      ],
      familyData: Object.entries(this.props.familyData).map(([key, value]) => ({
        key,
        value,
      })),
      isFamilyFlag: false,
      dimensions: null,
      isFlag: true,
      jwt: this.props.jwt,
      elementId: this.props.elementId,
      api_url: this.props.api_url,
      api_origin: this.props.api_origin,
      stocks: this.props.stocks
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.manufacturerFilter = this.manufacturerFilter.bind(this);
  }

  //remove all characters except a-z0-9 
  manufacturerFilter= (manufacturer) => {
    let filtered = manufacturer.replace(/[^a-z0-9]/gi, '');   
    // return filtered replacing characters to lowercase    
    return filtered.toLowerCase(); 
  }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.setState({
      dimensions: {
        width: this.container.clientWidth,
        height: this.container.clientHeight,
      },
    });
    if (this.props.isFamilyFlag) {
      this.setState({
        isFamilyFlag: true,
      });
    } else {
      this.setState({
        isFamilyFlag: false,
      });
    }
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  stableSort(array, sorting, sorting_field) {
    if (sorting != "no_filter") {
      const comparator = this.getComparator(sorting, sorting_field);
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
    } else {
      return array;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.rows !== prevProps.rows) {
      this.setState({
        rows: this.props.rows,
      });
    }
    if (this.props.stocks !== prevProps.stocks) {
      this.setState({
        stocks: this.props.stocks,
      });
    }
    if (this.props.data !== prevProps.data) {
      this.setState({
        data: this.props.data,
      });
    }

    if (this.props.isFamilyFlag !== prevProps.isFamilyFlag) {
      if (this.props.isFamilyFlag) {
        this.setState({
          isFamilyFlag: true,
        });
      } else {
        this.setState({
          isFamilyFlag: false,
        });
      }
    }

    if (this.state.isFlag) {
      this.setState({
        isFlag: false,
        dimensions: {
          width: this.container.clientWidth,
          height: this.container.clientHeight,
        },
      });
      EventEmitter.disptach("heightMainSection", this.container.clientHeight);
    }
  }

  showDetails(e, row, index) {
    this.setState({
      indexHover: index,
      product_hover_id: row.id.raw,
    });
  }
  showColumn(column) {
    const { resultsFields } = this.state;
    if (resultsFields.length === 0) return true;
    return resultsFields.includes(column);
  }

  hideDetails(e) {
    this.setState({
      indexHover: null,
      product_hover_id: "",
    });
  }

  removeIdFromArr = (id) => {
    let arr = [];
    // console.log("state: ", this.state);
    const old_ids = this.state.cart_product_ids;
    old_ids.map((val) => {
      if (val != id) {
        arr.push(val);
      }
    });

    this.setState({ cart_product_ids: arr });
  };
  productHandler = async (id, product) => {
    const { cart_product_ids, cart_products, jwt, api_origin, api_url, from } =
      this.state;
    let quantity = 1;
    const cartP = [...cart_product_ids, id];

    // this.state.cart_products.prods_q[id] = "1"; this code not working

    //Added for cart
    let cart = { ...cart_products };
    cart.prods_q = {};
    cart.prods_q[id] = "1";
    this.setState({
      cart_products: cart,
      cart_product_ids: cartP,
    });

    const data = JSON.stringify({
      product_id: id,
      quantity: quantity,
    });

    let addPrdDetls = await axios.post(api_url + `/carts`, data, {
      headers: {
        Accept: "application/json, text/javascript, */*; q=0.01",
        Authorization: jwt,
        Origin: api_origin,
      },
    });

    if (addPrdDetls) {
      this.props.onProductAddedToCart(product);
      var event = new CustomEvent("updatePHPCart", {
        detail: {
          product_id: product.id.raw,
        },
      });

      window.dispatchEvent(event);

      this.setState({
        selectProductId: id,
      });

      setTimeout(() => {
        this.setState({
          selectProductId: null,
        });
      }, 3000);
    }
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };
  handleProductClose = () => {
    this.setState({ isProductCardOpen: false });
  };
  handleProductOpen = (product) => {
    this.setState({ activeProductCode: product.id.raw });
    this.setState({ isProductCardOpen: true });
  };

  render() {
    const {
      width,
      rows,
      lang,
      isFamilyFlag,
      indexHover,
      logged,
      express,
      tariff,
      sortDirection,
      sortField,
      familyData,
      price_sort,
      product_hover_id,
      client_country_id,
      cart_products,
      fav_products,
      jwt,
      elementId,
      api_url,
      api_origin,
      stocks,
      customFilterManufacturer,
      customFilterManufacturerIds,
      sendAddEvent
    } = this.state;
    const { classes } = this.props;

   

    if (isFamilyFlag) {
      const result = rows.reduce(function (r, a) {
        const family = a?.main_family?.raw;
        const family_name = JSON.parse(family);
        r[family_name.alias] = r[family_name.alias] || [];
        r[family_name.alias].push(a);
        return r;
      }, Object.create(null));
      var arrayWithFamily = Object.entries(result).map(([key, value]) => ({
        key,
        value,
      }));
    }

    let sorting_field = "pvp";
    if (express) {
      sorting_field = "net";
    }

    if (!isFamilyFlag) {
      const from = this.props?.from;
      if (from) {
        return (
          <div style={{ width: "100%" }} ref={(el) => (this.container = el)}>
            <div className={`${classes.root} search-result-wrapper`}>
              <TableContainer
                component={Paper}
                className={
                  logged
                    ? "table-view-wrapper "
                    : "not-login table-view-wrapper"
                }
              >
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <EnhancedTableHead
                    from={from}
                    resultsFields={this.state?.resultsFields}
                    sortDirection={sortDirection}
                    sortField={sortField}
                    logged={logged}
                  />
                  <TableBody>
                    {this.stableSort(rows, price_sort, sorting_field).map(
                      (product, index) => {
                        let producto = stocks.find(producto => producto.product_id === parseInt(product.id.raw));
                        let stock = (producto ? producto.stock : 0);
                        let net = producto ? producto.net : 0;
                        let pvp = producto ? producto.price : 0;
                        let in_offer = producto ? producto.in_offer : false;
                        let in_offer_until = producto ? producto.in_offer_until : '0000-00-00';
                        let manufacturerId = null;
                        try {
                          manufacturerId = JSON.parse(product.product_data.raw).manufacturer_id;
                        } catch (e) {
                          manufacturerId = null;
                        }
                        // show only if manufacturerId is NOT included in customFilterManufacturerIds
                        if (customFilterManufacturerIds && customFilterManufacturerIds.includes(manufacturerId)) {
                          return null;
                        }

                        if (from === CUSTOM_SEARCH_BAR) {
                          return (
                            <React.Fragment key={index}>
                              <React.Fragment>
                                <TableRow
                                  key={product.id.raw}
                                  className={
                                    (product_hover_id !== "" &&
                                    indexHover === index
                                      ? "product-row-hover"
                                      : "") +
                                    (product?.not_discontinued?.raw == "false"
                                      ? " row-pink"
                                      : "")
                                  }>
                                  {this.showColumn(MAIN_FAMILY) && (
                                    <TableCell className="fam-col">
                                      <div
                                        style={{
                                          width: "7px",
                                          height: "32px",
                                          margin: "0 auto",
                                          backgroundColor: JSON.parse(
                                            product.main_family.raw
                                          ).color,
                                        }}
                                      ></div>
                                    </TableCell>
                                  )}
                                  {this.showColumn(IMAGE) && (
                                    <TableCell
                                      align="right"
                                      className="webcode-col img-col"
                                    >
                                      {this.props?.openProduct ? (
                                        <a
                                          href={
                                            "/producto.php?cod_producto=" +
                                            product.id.raw
                                          }
                                          target={this.props?.openOn}
                                        >
                                          <img
                                            className={`${classes.listImage} list-img`}
                                            /*src={JSON.parse(product.product_data.raw).photo}*/
                                            src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                            alt={
                                              product.autonames?.raw != ""
                                                ? JSON.parse(product.autonames.raw)[this.state.lang]
                                                : JSON.parse(product.product_data.raw).names[this.state.lang]
                                            }
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "/common/fotos/default.png";
                                            }}
                                          />
                                        </a>
                                      ) : (
                                        <img
                                          className={`${classes.listImage} list-img`}
                                          /*src={JSON.parse(product.product_data.raw).photo}*/
                                          src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                          alt={
                                            product.autonames?.raw != ""
                                              ? JSON.parse(product.autonames.raw)[this.state.lang]
                                              : JSON.parse(product.product_data.raw).names[this.state.lang]
                                          }
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/common/fotos/default.png";
                                          }}
                                        />
                                      )}
                                    </TableCell>
                                  )}
                                  {this.showColumn(PRODUCT_IMAGE) && (
                                    <TableCell className="desk-hide img-col">
                                      {JSON.parse(product.product_data.raw).photo != "" ? (
                                        <img
                                          className={
                                            "list-img hideThis " + classes.cover
                                          }
                                          /*src={JSON.parse(product.product_data.raw).photo}*/
                                          src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                          alt={
                                            product.autonames?.raw != ""
                                              ? JSON.parse(product.autonames.raw)[this.state.lang]
                                              : JSON.parse(product.product_data.raw).names[this.state.lang]
                                          }
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/common/fotos/default.png";
                                          }}
                                        />
                                      ) : this.props?.openProduct ? (
                                        <a
                                          href={
                                            "/producto.php?cod_producto=" +
                                            product.id.raw
                                          }
                                          target={this.props?.openOn}
                                        >
                                          <CardMedia
                                            className={
                                              "list-img " + classes.cover
                                            }
                                            image="/common/fotos/default.png"
                                            component="img"
                                            title=""
                                          />
                                        </a>
                                      ) : (
                                        <CardMedia
                                          className={
                                            "list-img " + classes.cover
                                          }
                                          image="/common/fotos/default.png"
                                          component="img"
                                          title=""
                                        />
                                      )}
                                    </TableCell>
                                  )}
                                  {this.showColumn(CODE) && (
                                    <TableCell
                                    align="right"
                                    className="webcode-col sm-hide"
                                  >
                                    {this.props?.openProduct ? (
                                      <a
                                        href={"/producto.php?cod_producto=" + product?.id?.raw}
                                        target={this.props?.openOn}
                                      >
                                        {product.id.raw}
                                      </a>
                                    ) : (
                                      product.id.raw
                                    )}
                                  </TableCell>
                                  
                                  )}
                                  {this.showColumn(MANUFACTURER) && (
                                    <TableCell className="fabricante-col ellipsis-col small">
                                    {this.props?.openProduct ? (
                                      <a
                                        href={"/producto.php?cod_producto=" + product?.id?.raw}
                                        target={this.props?.openOn}
                                      >
                                        {product.manufacturer.raw}
                                      </a>
                                    ) : (
                                      product.manufacturer.raw
                                    )}
                                  </TableCell>
                                  
                                  )}
                                  {this.showColumn(REFERENCE) && (
                                    <TableCell className={`${classes.textContainer} ref-col ellipsis-col large`}>
                                    {this.props?.openProduct ? (
                                      <a
                                        href={"/producto.php?cod_producto=" + product?.id?.raw}
                                        target={this.props?.openOn}
                                      >
                                        {product.ref1.raw}
                                      </a>
                                    ) : (
                                      product.ref1.raw
                                    )}
                                  </TableCell>
                                  
                                  )}
                                  {this.showColumn(NAME) && (
                                    <TableCell className={`${classes.textContainer} col-name ellipsis-col large`}>
                                    <div className="truncate-two-line">
                                      {this.props?.openProduct ? (
                                        <a
                                          href={"/producto.php?cod_producto=" + product?.id?.raw}
                                          target={this.props?.openOn}
                                        >
                                          {product?.not_discontinued?.raw == "false" ? <Trans>---Discontinued---</Trans> : ""}
                                          {product?.autonames?.raw != "" ? JSON.parse(product.autonames.raw)[this.state.lang] : JSON.parse(product.product_data.raw).names[this.state.lang]}
                                        </a>
                                      ) : (
                                        <>
                                          {product?.not_discontinued?.raw == "false" ? <Trans>---Discontinued---</Trans> : ""}
                                          {product?.autonames?.raw != "" ? JSON.parse(product.autonames.raw)[this.state.lang] : JSON.parse(product.product_data.raw).names[this.state.lang]}
                                        </>
                                      )}
                                    </div>
                                  </TableCell>                                  
                                  )}
                                  {this.showColumn(PVP_NETO) && (
                                    <TableCell
                                      className={`${classes.textContainer} pvpneto-col sm-hide`}
                                    >
                                      {logged ? (
                                        <span>
                                          {pvp < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            pvp?.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      {logged && express ? (
                                        <span className="net-value sm-hide">
                                          {net < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            net.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  )}
                                  {this.showColumn(NET_PRICE) && (
                                    <TableCell className=" netprice-col sm-hide">
                                      {logged && express ? (
                                        <span>
                                          {net < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            net.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  )}
                                  {this.showColumn(LIST_PRICE) && (
                                    <TableCell>
                                      {logged ? (
                                        <span>
                                          {pvp < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            pvp.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  )}
                                  {this.showColumn(STOCK) && (
                                    <TableCell className="stock-col sm-hide">
                                      {/*product.stock.raw*/}
                                      {stock <= 0 ? (
                                        <div className="progress-wrapper data-tooltip">
                                          <div className="tooltip-txt">
                                            <Trans>On request</Trans>
                                          </div>
                                          <div className="progress-title">
                                            <Trans>OR</Trans>
                                          </div>
                                          <div className="progressbar">
                                            <div
                                              className="progressbar-inner"
                                              style={{ width: "2%" }}
                                            ></div>
                                          </div>
                                        </div>
                                      ) : stock < 10 ? (
                                        <div className="progress-wrapper progress-low">
                                          <div className="progress-title">
                                            {stock}
                                          </div>
                                          <div className="progressbar">
                                            <div
                                              className="progressbar-inner"
                                              style={{
                                                width:
                                                  (stock * 100) /
                                                    50 +
                                                  `%`,
                                              }}
                                            ></div>
                                          </div>
                                        </div>
                                      ) : stock >= 10 &&
                                      stock < 50 ? (
                                        <div className="progress-wrapper progress-medium">
                                          <div className="progress-title">
                                            {stock}
                                          </div>
                                          <div className="progressbar">
                                            <div
                                              className="progressbar-inner"
                                              style={{
                                                width:
                                                  (stock * 100) /
                                                    50 +
                                                  `%`,
                                              }}
                                            ></div>
                                          </div>
                                        </div>
                                      ) : (
                                        stock >= 50 && (
                                          <div className="progress-wrapper progress-full">
                                            <div className="progress-title">
                                              {stock}
                                            </div>
                                            <div className="progressbar">
                                              <div
                                                className="progressbar-inner"
                                                style={{ width: `100%` }}
                                              ></div>
                                            </div>
                                          </div>
                                        )
                                      )}
                                    </TableCell>
                                  )}
                                  {/* custom cart button  */ logged &&
                                  product?.not_discontinued?.raw == "false" ? (
                                    <TableCell className="sm-hide">
                                      <Typography
                                        className="btn btn-watch graybg-btn"
                                        component="a"
                                        href={
                                          "/producto.php?cod_producto=" +
                                          product.id.raw
                                        }
                                      ><Trans>Watch</Trans>
                                      </Typography>
                                    </TableCell>
                                  ):this.state.showAddToCart && logged ? (
                                    <TableCell className="">
                                      <div className="cell-wrap">
                                        {this.props?.showPlusButton && JSON.stringify(
                                          this.state.cart_product_ids
                                        ).includes(product.id.raw) ? (
                                          <CustomAddButton
                                            data={product}
                                            jwt={jwt}
                                            cart_prods={
                                              this.state.cart_products.prods_q
                                            }
                                            removeIdFromArr={
                                              this.removeIdFromArr
                                            }
                                            client_country_id={
                                              client_country_id
                                            }
                                            api_origin={api_origin}
                                            api_url={api_url}
                                            onProductQtyModifiedOnCart={
                                              this.props
                                                .onProductQtyModifiedOnCart
                                            }
                                            removeProductFromCart={
                                              this.props
                                                .onProductDeletedFromCart
                                            }
                                            onProductAddedToCart={
                                              this.props.onProductAddedToCart
                                            }
                                          />
                                        ) : (
                                          <Typography
                                            className="btn bluebg-btn addCarro"
                                            component="a"
                                            onClick={() =>
                                              this.productHandler(
                                                product.id.raw,
                                                product
                                              )
                                            }
                                            data-producto={product.id.raw}
                                            data-value1={
                                              JSON.parse(product.product_data.raw).manufacturer_id
                                            }
                                          >
                                            <Trans>Add</Trans>
                                          </Typography>
                                        )}
                                        {this.props?.from ===
                                          CUSTOM_SEARCH_BAR &&
                                          this.state?.showAddToList && (
                                            <AddToListButton
                                              jwt={jwt}
                                              data={product}
                                              api_origin={api_origin}
                                              api_url={api_url}
                                              onProductAddedToList={
                                                this.props.onProductAddedToList
                                              }
                                            />
                                          )}
                                      </div>
                                    </TableCell>
                                  ):("")}                                                                    
                                  {/* custom select button */ logged && this.props?.showSelectButton ? (
                                    <TableCell className="sm-hide">
                                      <Typography
                                        className={
                                          this.props?.selectedProductsCode.includes(
                                            product.webcode.raw
                                          )
                                            ? "btn btn-grayb"
                                            : "btn bluebg-btn"
                                        }
                                        component="a"
                                        onClick={() => {
                                          this.props?.onProductSelected(
                                            product
                                          );
                                          this.props?.handleSelectedProductClick(
                                            product
                                          );
                                        }}
                                      >
                                        <Trans>Select</Trans>
                                      </Typography>                                      
                                    </TableCell>
                                  ) : ("")}
                                  {/* custom qty and plus button*/ logged && this.props?.showPlusButton ? (
                                    <TableCell className="sm-hide">
                                      <AddProductButton data={product} elementId={elementId} showPlusQtyButton={this.props?.showPlusQtyButton}></AddProductButton>
                                    </TableCell>
                                  ):("")}
                                  <TableCell className="desk-hide product-action">
                                    <ProductModal
                                      open={
                                        this.state.isProductCardOpen &&
                                        this.state.activeProductCode ===
                                          product.id.raw
                                      }
                                      onClose={this.handleProductClose}
                                      onOpen={() =>
                                        this.handleProductOpen(product)
                                      }
                                    >
                                      <CardProduct
                                        custom={from}
                                        handleClose={this.handleProductClose}
                                        data={product}
                                        lang={lang}
                                        logged={logged}
                                        express={express}
                                        tariff={tariff}
                                        client_country_id={client_country_id}
                                        customFilterManufacturer={customFilterManufacturer}
                                        customFilterManufacturerIds={customFilterManufacturerIds}
                                        cart_products={cart_products}
                                        fav_products={fav_products}
                                        jwt={jwt}
                                        sa={false}
                                        api_origin={api_origin}
                                        api_url={api_url}
                                        onProductQtyModifiedOnCart={
                                          this.props.onProductQtyModifiedOnCart
                                        }
                                        removeProductFromCart={
                                          this.props.onProductDeletedFromCart
                                        }
                                        onProductAddedToCart={
                                          this.props.onProductAddedToCart
                                        }
                                        stocks={stocks}  
                                        sendAddEvent={true}     
                                        elementId={this.props.elementId}                                 
                                      />
                                    </ProductModal>
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            </React.Fragment>
                          );
                        } else {
                          <React.Fragment key={index}>
                            <React.Fragment>
                              <TableRow
                                key={product.id.raw}
                                className={
                                  (product_hover_id !== "" &&
                                  indexHover === index
                                    ? "product-row-hover"
                                    : "") +
                                  (product?.not_discontinued?.raw == "false"
                                    ? " row-pink"
                                    : "")
                                }
                                onMouseOver={(e) =>
                                  this.showDetails(e, product, index)
                                }
                              >
                                <TableCell className="sm-hide fam-col">
                                  <div
                                    style={{
                                      width: "7px",
                                      height: "32px",
                                      margin: "0 auto",
                                      backgroundColor: JSON.parse(
                                        product.main_family.raw
                                      ).color,
                                    }}
                                  ></div>
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className="webcode-col"
                                >
                                  <img
                                    className={`${classes.listImage} list-img `}
                                    /*src={JSON.parse(product.product_data.raw).photo}*/
                                    src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                    alt={
                                      product.autonames?.raw != ""
                                        ? JSON.parse(product.autonames.raw)[this.state.lang]
                                        : JSON.parse(product.product_data.raw).names[this.state.lang]
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/common/fotos/default.png";
                                    }}
                                  />
                                </TableCell>
                                <TableCell className="desk-hide img-col">
                                  {JSON.parse(product.product_data.raw).photo != "" ? (
                                    <img
                                      className={
                                        "list-img hideThis " + classes.cover
                                      }
                                      /*src={JSON.parse(product.product_data.raw).photo}*/
                                      src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                      alt={
                                        product.autonames?.raw != ""
                                          ? JSON.parse(product.autonames.raw)[this.state.lang]
                                          : JSON.parse(product.product_data.raw).names[this.state.lang]
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "/common/fotos/default.png";
                                      }}
                                    />
                                  ) : (
                                    <CardMedia
                                      className={"list-img " + classes.cover}
                                      image="/common/fotos/default.png"
                                      component="img"
                                      title=""
                                    />
                                  )}                                  
                                </TableCell>
                                <TableCell
                                  align="right"
                                  className="webcode-col"
                                >
                                  {product.id.raw}
                                </TableCell>
                                <TableCell className="fabricante-col sm-hide">
                                  {product.manufacturer.raw}
                                </TableCell>
                                {width > 1500 ? (
                                  <TableCell
                                    className={`${classes.textContainer} ref-col sm-hide`}
                                  >
                                    {product.ref1.raw}
                                  </TableCell>
                                ) : // :
                                // width < 768 ? (
                                //   <TableCell className={`${classes.textContainer} ref-col`}>{product.ref1.raw}</TableCell>
                                // )
                                null}
                                <TableCell
                                  className={`${classes.textContainer} col-name`}
                                >
                                  {product?.not_discontinued?.raw == "false" ? (
                                    <Trans>---Discontinued--- </Trans>
                                  ) : (
                                    ""
                                  )}
                                  {product?.autonames?.raw != ""
                                    ? JSON.parse(product.autonames.raw)[this.state.lang]
                                    : JSON.parse(product.product_data.raw).names[this.state.lang]}
                                </TableCell>
                                <TableCell
                                  className={`${classes.textContainer} desk-hide pvpneto-col`}
                                >
                                  {logged && express ? (
                                    <span>
                                      {pvp < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        pvp.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  {logged && express ? (
                                    <span className="net-value">
                                      {net < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        net.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                <TableCell className="sm-hide netprice-col">
                                  {logged && express ? (
                                    <span>
                                      {net < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        net.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                                {width >= 1281 ? (
                                  <TableCell className="sm-hide">
                                    {logged ? (
                                      <span>
                                        {pvp < 0.01 ? (
                                          <Trans>* Request price</Trans>
                                        ) : (
                                          pvp.toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                ) : width <= 1024 ? (
                                  <TableCell className="sm-hide">
                                    {logged ? (
                                      <span>
                                        {pvp < 0.01 ? (
                                          <Trans>* Request price</Trans>
                                        ) : (
                                          pvp.toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                ) : null}
                                <TableCell className="stock-col sm-hide">
                                  {/*product.stock.raw*/}
                                  {stock <= 0 ? (
                                    <div className="progress-wrapper data-tooltip">
                                      <div className="tooltip-txt">
                                        <Trans>On request</Trans>
                                      </div>
                                      <div className="progress-title">
                                        <Trans>OR</Trans>
                                      </div>
                                      <div className="progressbar">
                                        <div
                                          className="progressbar-inner"
                                          style={{ width: "2%" }}
                                        ></div>
                                      </div>
                                    </div>
                                  ) : stock < 10 ? (
                                    <div className="progress-wrapper progress-low">
                                      <div className="progress-title">
                                        {stock}
                                      </div>
                                      <div className="progressbar">
                                        <div
                                          className="progressbar-inner"
                                          style={{
                                            width:
                                              (stock * 100) / 50 +
                                              `%`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  ) : stock >= 10 &&
                                  stock < 50 ? (
                                    <div className="progress-wrapper progress-medium">
                                      <div className="progress-title">
                                        {stock}
                                      </div>
                                      <div className="progressbar">
                                        <div
                                          className="progressbar-inner"
                                          style={{
                                            width:
                                              (stock * 100) / 50 +
                                              `%`,
                                          }}
                                        ></div>
                                      </div>
                                    </div>
                                  ) : (
                                    stock >= 50 && (
                                      <div className="progress-wrapper progress-full">
                                        <div className="progress-title">
                                          {stock}
                                        </div>
                                        <div className="progressbar">
                                          <div
                                            className="progressbar-inner"
                                            style={{ width: `100%` }}
                                          ></div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </TableCell>                               
                              </TableRow>
                              {product_hover_id == product.id.raw && (
                                <TableRow
                                  id={"hover_" + product.id.raw}
                                  className={`${classes.modalProductDiv} product-table-card`}
                                >
                                  <ProductListCard
                                    data-product={product.id.raw}
                                    /*data-img={JSON.parse(product.product_data.raw).photo}*/
                                    data-img={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                    role="row"
                                    data={product}
                                    lang={lang}
                                    logged={logged}
                                    express={express}
                                    tariff={tariff}
                                    client_country_id={client_country_id}
                                    cart_products={cart_products}
                                    fav_products={fav_products}
                                    jwt={jwt}
                                    api_url={api_url}
                                    stocks={stocks}
                                    customFilterManufacturerIds={customFilterManufacturerIds}
                                    sendAddEvent={true}
                                  />
                                </TableRow>
                              )}
                            </React.Fragment>
                          </React.Fragment>;
                        }
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ width: "100%" }} ref={(el) => (this.container = el)}>
            <div className={`${classes.root} search-result-wrapper`}>
              <TableContainer
                component={Paper}
                className={
                  logged
                    ? "table-view-wrapper "
                    : "not-login table-view-wrapper"
                }
              >
                <Table className={classes.table}>
                  <EnhancedTableHead
                    sortDirection={sortDirection}
                    sortField={sortField}
                    logged={logged}
                  />
                  <TableBody>
                    {this.stableSort(rows, price_sort, sorting_field).map(
                      (product, index) => {
                        let producto = stocks.find(producto => producto.product_id === parseInt(product.id.raw));
                        let stock = (producto ? producto.stock : 0);
                        let net = producto ? producto.net : 0;
                        let pvp = producto ? producto.price : 0;
                        let in_offer = producto ? producto.in_offer : false;
                        let in_offer_until = producto ? producto.in_offer_until : '0000-00-00';
                        return (
                        <React.Fragment key={index}>
                          <React.Fragment>
                            <TableRow
                              key={product.id.raw}
                              className={
                                (product_hover_id !== "" && indexHover === index
                                  ? "product-row-hover"
                                  : "") +
                                (product?.not_discontinued?.raw == "false"
                                  ? " row-pink"
                                  : "")
                              }
                              onMouseOver={(e) =>
                                this.showDetails(e, product, index)
                              }
                              // onMouseLeave={(e) => this.hideDetails(e)}
                            >
                              <TableCell className="sm-hide fam-col">
                                <div
                                  style={{
                                    width: "7px",
                                    height: "32px",
                                    margin: "0 auto",
                                    backgroundColor: JSON.parse(
                                      product.main_family.raw
                                    ).color,
                                  }}
                                ></div>
                              </TableCell>
                              <TableCell align="right" className="webcode-col">
                                <img
                                  className={`${classes.listImage} list-img `}
                                  /*src={JSON.parse(product.product_data.raw).photo}*/
                                  src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                  alt={
                                    product.autonames?.raw != ""
                                      ? JSON.parse(product.autonames.raw)[this.state.lang]
                                      : JSON.parse(product.product_data.raw).names[this.state.lang]
                                  }
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "/common/fotos/default.png";
                                  }}
                                />
                              </TableCell>
                              <TableCell className="desk-hide img-col">
                                {JSON.parse(product.product_data.raw).photo != "" ? (
                                  <img
                                    className={
                                      "list-img hideThis " + classes.cover
                                    }
                                    /*src={JSON.parse(product.product_data.raw).photo}*/
                                    src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                    alt={
                                      product.autonames?.raw != ""
                                        ? JSON.parse(product.autonames.raw)[this.state.lang]
                                        : JSON.parse(product.product_data.raw).names[this.state.lang]
                                    }
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/common/fotos/default.png";
                                    }}
                                  />
                                ) : (
                                  <CardMedia
                                    className={"list-img " + classes.cover}
                                    image="/common/fotos/default.png"
                                    component="img"
                                    title=""
                                  />
                                )}

                                {/* <img class="MuiCardMedia-root list-img withI18nextTranslation(ProductListCard)-cover-26 MuiCardMedia-media MuiCardMedia-img" src="/common/fotos/default.png" title=""></img> */}
                              </TableCell>
                              <TableCell align="right" className="webcode-col">
                                {product.id.raw}
                              </TableCell>
                              <TableCell className="fabricante-col sm-hide">
                                {product.manufacturer.raw}
                              </TableCell>
                              {width > 1500 ? (
                                <TableCell
                                  className={`${classes.textContainer} ref-col sm-hide`}
                                >
                                  {product.ref1.raw}
                                </TableCell>
                              ) : // :
                              // width < 768 ? (
                              //   <TableCell className={`${classes.textContainer} ref-col`}>{product.ref1.raw}</TableCell>
                              // )
                              null}
                              <TableCell
                                className={`${classes.textContainer} col-name`}
                              >
                                {product?.not_discontinued?.raw == "false" ? (
                                  <Trans>---Discontinued--- </Trans>
                                ) : (
                                  ""
                                )}
                                {product?.autonames?.raw != ""
                                  ? JSON.parse(product.autonames.raw)[this.state.lang]
                                  : JSON.parse(product.product_data.raw).names[this.state.lang]}
                              </TableCell>
                              <TableCell
                                className={`${classes.textContainer} desk-hide pvpneto-col`}
                              >
                                {logged && express ? (
                                  <span>
                                    {pvp < 0.01 ? (
                                      <Trans>* Request price</Trans>
                                    ) : (
                                      pvp.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                                {logged && express ? (
                                  <span className="net-value">
                                    {net < 0.01 ? (
                                      <Trans>* Request price</Trans>
                                    ) : (
                                      net.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                              <TableCell className="sm-hide netprice-col">
                                {logged && express ? (
                                  <span>
                                    {net < 0.01 ? (
                                      <Trans>* Request price</Trans>
                                    ) : (
                                      net.toFixed(2)
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                              {width >= 1281 ? (
                                <TableCell className="sm-hide">
                                  {logged ? (
                                    <span>
                                      {pvp < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        pvp.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              ) : width <= 1024 ? (
                                <TableCell className="sm-hide">
                                  {logged ? (
                                    <span>
                                      {pvp < 0.01 ? (
                                        <Trans>* Request price</Trans>
                                      ) : (
                                        pvp.toFixed(2)
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              ) : null}
                              <TableCell className="stock-col sm-hide">
                                {/*product.stock.raw*/}
                                {stock <= 0 ? (
                                  <div className="progress-wrapper data-tooltip">
                                    <div className="tooltip-txt">
                                      <Trans>On request</Trans>
                                    </div>
                                    <div className="progress-title">
                                      <Trans>OR</Trans>
                                    </div>
                                    <div className="progressbar">
                                      <div
                                        className="progressbar-inner"
                                        style={{ width: "2%" }}
                                      ></div>
                                    </div>
                                  </div>
                                ) : stock < 10 ? (
                                  <div className="progress-wrapper progress-low">
                                    <div className="progress-title">{stock}</div>
                                    <div className="progressbar">
                                      <div
                                        className="progressbar-inner"
                                        style={{
                                          width:
                                            (stock * 100) / 50 +
                                            `%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                ) : stock >= 10 &&
                                stock < 50 ? (
                                  <div className="progress-wrapper progress-medium">
                                    <div className="progress-title">{stock}</div>
                                    <div className="progressbar">
                                      <div
                                        className="progressbar-inner"
                                        style={{
                                          width:
                                            (stock * 100) / 50 +
                                            `%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                ) : (
                                  stock >= 50 && (
                                    <div className="progress-wrapper progress-full">
                                      <div className="progress-title">
                                        {stock}
                                      </div>
                                      <div className="progressbar">
                                        <div
                                          className="progressbar-inner"
                                          style={{ width: `100%` }}
                                        ></div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </TableCell>                              
                            </TableRow>
                            {product_hover_id == product.id.raw && (
                              <TableRow
                                id={"hover_" + product.id.raw}
                                className={`${classes.modalProductDiv} product-table-card`}
                              >
                                <ProductListCard
                                  data-product={product.id.raw}
                                  /*data-img={JSON.parse(product.product_data.raw).photo}*/
                                  data-img={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                  role="row"
                                  data={product}
                                  lang={lang}
                                  logged={logged}
                                  express={express}
                                  tariff={tariff}
                                  client_country_id={client_country_id}
                                  cart_products={cart_products}
                                  fav_products={fav_products}
                                  jwt={jwt}
                                  stocks={stocks}
                                  api_url={api_url}
                                  sendAddEvent={true}
                                  customFilterManufacturerIds={customFilterManufacturerIds}                                  
                                />
                              </TableRow>
                            )}
                          </React.Fragment>
                        </React.Fragment>
                        )
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        );
      }
    } else {
      return (
        <div style={{ width: "100%" }} ref={(el) => (this.container = el)}>
          <div className={`${classes.root} search-result-wrapper`}>
            <TableContainer
              component={Paper}
              className={
                logged ? "table-view-wrapper " : "not-login table-view-wrapper"
              }
            >
              <Table className={classes.table}>
                <EnhancedTableHead
                  sortDirection={sortDirection}
                  sortField={sortField}
                  logged={logged}
                />
                <TableBody>
                  {this.stableSort(
                    arrayWithFamily,
                    price_sort,
                    sorting_field
                  ).map((row, index) =>(
                    <React.Fragment key={index}>
                      <TableRow className="familyname-row">
                        <TableCell className="family-icon sm-hide">
                          {row.key == "f" ? (
                            <img
                              src={`/img/svgs/f14.svg`}
                              alt="family-list-icon"
                              styles={{ width: "15px", height: "15px" }}
                            />
                          ) : (
                            <img
                              src={`/img/svgs/${row.key}.svg`}
                              alt="family-list-icon"
                              styles={{ width: "15px", height: "15px" }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          colSpan={
                            width <= 1024
                              ? 6
                              : width <= 1280
                              ? 5
                              : width <= 1500
                              ? 6
                              : 7
                          }
                          className="family-name"
                        >
                          {row.key == "f" ? (
                            <span>
                              <Trans>Not Assigned</Trans>
                            </span>
                          ) : (
                            familyData?.length > 0 &&
                            familyData.map(
                              (family) =>
                                family.key == row.key && (
                                  <span>{family.value}</span>
                                )
                            )
                          )}
                        </TableCell>
                      </TableRow>
                      {row?.value?.length > 0 &&
                        row?.value?.map((product, index1) => 
                          {
                            let producto = stocks.find(producto => producto.product_id === parseInt(product.id.raw));
                            let stock = (producto ? producto.stock : 0);
                            let net = producto ? producto.net : 0;
                            let pvp = producto ? producto.price : 0;
                            let in_offer = producto ? producto.in_offer : false;
                            let in_offer_until = producto ? producto.in_offer_until : '0000-00-00';
                            return (
                              <React.Fragment key={index1}>
                                <TableRow
                                  key={product.id.raw}
                                  className={
                                    product_hover_id !== "" && indexHover === index1
                                      ? "product-row-hover"
                                      : ""
                                  }
                                  onMouseOver={(e) =>
                                    this.showDetails(e, product, index1)
                                  }                              
                                >
                                  <TableCell className="sm-hide fam-col">
                                    <div
                                      style={{
                                        width: "7px",
                                        height: "32px",
                                        margin: "0 auto",
                                        backgroundColor: JSON.parse(
                                          product.main_family.raw
                                        ).color,
                                      }}
                                    ></div>
                                  </TableCell>
                                  <TableCell align="right" className="webcode-col">
                                    <img
                                      className={`${classes.listImage} list-img `}
                                      /*src={JSON.parse(product.product_data.raw).photo}*/
                                      src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                      alt={
                                        product.autonames?.raw != ""
                                          ? JSON.parse(product.autonames.raw)[this.state.lang]
                                          : JSON.parse(product.product_data.raw).names[this.state.lang]
                                      }
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "/common/fotos/default.png";
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell className="desk-hide img-col">
                                    {JSON.parse(product.product_data.raw).photo != "" ? (
                                      <img
                                        className={"list-img " + classes.cover}
                                        /*src={JSON.parse(product.product_data.raw).photo}*/
                                        src={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                        alt={
                                          product.autonames?.raw != ""
                                            ? JSON.parse(product.autonames.raw)[this.state.lang]
                                            : JSON.parse(product.product_data.raw).names[this.state.lang]
                                        }
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "/common/fotos/default.png";
                                        }}
                                      />
                                    ) : (
                                      <CardMedia
                                        className={"list-img " + classes.cover}
                                        image="/common/fotos/default.png"
                                        component="img"
                                        title=""
                                      />
                                    )}
                                    {/* <img class="MuiCardMedia-root list-img withI18nextTranslation(ProductListCard)-cover-26 MuiCardMedia-media MuiCardMedia-img" src="/common/fotos/default.png" title=""></img> */}
                                  </TableCell>
                                  <TableCell align="right" className="webcode-col">
                                    {product.id.raw}
                                  </TableCell>
                                  <TableCell className="fabricante-col sm-hide">
                                    {product.manufacturer.raw}
                                  </TableCell>
                                  {width > 1500 ? (
                                    <TableCell
                                      className={`${classes.textContainer} ref-col sm-hide`}
                                    >
                                      {product.ref1.raw}
                                    </TableCell>
                                  ) : null}
                                  <TableCell
                                    className={`${classes.textContainer} col-name`}
                                  >
                                    {product?.autonames?.raw != ""
                                      ? JSON.parse(product.autonames.raw)[this.state.lang]
                                      : JSON.parse(product.product_data.raw).names[this.state.lang]}
                                  </TableCell>
                                  <TableCell
                                    className={`${classes.textContainer} desk-hide pvpneto-col`}
                                  >
                                    {logged ? (
                                      <span>
                                        {pvp < 0.01 ? (
                                          <Trans>* Request price</Trans>
                                        ) : (
                                          pvp?.toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    {logged && express ? (
                                      <span className="net-value">
                                        {net < 0.01 ? (
                                          <Trans>* Request price</Trans>
                                        ) : (
                                          net.toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  <TableCell className="sm-hide netprice-col">
                                    {logged && express ? (
                                      <span>
                                        {net < 0.01 ? (
                                          <Trans>* Request price</Trans>
                                        ) : (
                                          net.toFixed(2)
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </TableCell>
                                  {width >= 1281 ? (
                                    <TableCell className="sm-hide">
                                      {logged ? (
                                        <span>
                                          {pvp < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            pvp.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  ) : width <= 1024 ? (
                                    <TableCell className="sm-hide">
                                      {logged ? (
                                        <span>
                                          {pvp < 0.01 ? (
                                            <Trans>* Request price</Trans>
                                          ) : (
                                            pvp?.toFixed(2)
                                          )}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  ) : null}
                                  <TableCell className="stock-col sm-hide">
                                    {stock <= 0 ? (
                                      <div className="progress-wrapper data-tooltip">
                                        <div className="tooltip-txt">
                                          <Trans>On request</Trans>
                                        </div>
                                        <div className="progress-title">
                                          <Trans>OR</Trans>
                                        </div>
                                        <div className="progressbar">
                                          <div
                                            className="progressbar-inner"
                                            style={{ width: "2%" }}
                                          ></div>
                                        </div>
                                      </div>
                                    ) : stock < 10 ? (
                                      <div className="progress-wrapper progress-low">
                                        <div className="progress-title">{stock}</div>
                                        <div className="progressbar">
                                          <div
                                            className="progressbar-inner"
                                            style={{
                                              width:
                                                (stock * 100) / 50 +
                                                `%`,
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                    ) : stock >= 10 &&
                                    stock < 50 ? (
                                      <div className="progress-wrapper progress-medium">
                                        <div className="progress-title">{stock}</div>
                                        <div className="progressbar">
                                          <div
                                            className="progressbar-inner"
                                            style={{
                                              width:
                                                (stock * 100) / 50 +
                                                `%`,
                                            }}
                                          ></div>
                                        </div>
                                      </div>
                                    ) : (
                                      stock >= 50 && (
                                        <div className="progress-wrapper progress-full">
                                          <div className="progress-title">
                                            {stock}
                                          </div>
                                          <div className="progressbar">
                                            <div
                                              className="progressbar-inner"
                                              style={{ width: `100%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </TableCell>
                                </TableRow>
                                {product_hover_id == product.id.raw && (
                                  <TableRow
                                    id={"hover_" + product.id.raw}
                                    className={`${classes.modalProductDiv} product-table-card`}
                                  >
                                    <ProductListCard
                                      data-product={product.id.raw}
                                      /*data-img={JSON.parse(product.product_data.raw).photo}*/
                                      data-img={'/common/fotos/'+this.manufacturerFilter(product.manufacturer.raw)+'/'+this.manufacturerFilter(product.ref1.raw)+'.jpg'}
                                      role="row"
                                      data={product}
                                      lang={lang}
                                      logged={logged}
                                      express={express}
                                      tariff={tariff}
                                      client_country_id={client_country_id}
                                      cart_products={cart_products}
                                      fav_products={fav_products}
                                      jwt={jwt}
                                      stocks={stocks}
                                    />
                                  </TableRow>
                                )}
                              </React.Fragment>
                          
                            );
                          }
                        )
                      }
                    </React.Fragment>
                    )                  
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      );
    }
  }
}

TableProducts.defaultProps = {
  from: false,
};
export default withStyles(styles)(withTranslation()(TableProducts));
